export default __webpack_public_path__ + "static/media/thumbnail.2e7b8eff.png";